import { render, staticRenderFns } from "./badge_current.vue?vue&type=template&id=442a8544&scoped=true&"
import script from "./badge_current.vue?vue&type=script&lang=js&"
export * from "./badge_current.vue?vue&type=script&lang=js&"
import style0 from "./badge_current.vue?vue&type=style&index=0&id=442a8544&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a8544",
  null
  
)

export default component.exports